import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/components/IFrame.js
var IFrame = class {
  constructor(el) {
    this.input = el.querySelector("input");
    if (el.hasAttribute("data-simple-video")) {
      this.video = el.querySelector("video");
      this.input.addEventListener("change", () => this.handleChange("video"));
    } else {
      this.iframe = el.querySelector("iframe");
      this.input.addEventListener("change", () => this.handleChange("iframe"));
    }
  }
  handleChange(type) {
    if (!this.input.checked) {
      if (type === "iframe") {
        this.iframe.setAttribute("src", this.iframe.src);
      } else {
        this.video.pause();
      }
    } else {
      if (type === "iframe") {
        this.iframe.removeAttribute("loading");
      } else {
        this.video.play();
      }
    }
  }
};
var IFrame_default = IFrame;
export {
  IFrame_default as default
};
